import { getResourceStateful } from 'app/state/resource'
import { accountResource, statsResource } from 'features/account/state/accountSlice'
import { Account, AccountStatsDetails } from 'features/account/types'
import { all, call } from 'redux-saga/effects'
import { QuotaCalculationParams, quotaDefinitions } from '../quotas'
import { QuotaTypes } from '../types'
import { calculateQuota } from '../utils'

export function* getQuota(type: QuotaTypes) {
  try {
    const [stats, account]: [AccountStatsDetails, Account] = yield all([
      call(getResourceStateful, statsResource),
      call(getResourceStateful, accountResource)
    ])

    const quotaContext: QuotaCalculationParams = {
      stats,
      quotas: account.quotas
    }
    const quotaDefinition = quotaDefinitions[type]
    if (!quotaDefinition) {
      throw new Error(`invalid quota type: ${type}`)
    }
    return calculateQuota(type, quotaDefinition(quotaContext))
  } catch (e) {
    throw new Error(`getQuota for ${type} failed: ${e}`)
  }
}
